import Utils from "../../Scalesoft.Shared.FrontEnd/Scripts/Utils";
import MainLayout from "./MainLayout";
import ResponsiveNavbarItemsList from "./ResponsiveNavbarItemsList";

jq(() => {
    const navbarItemsList = new ResponsiveNavbarItemsList();
    const mainLayout = new MainLayout(navbarItemsList);
    const utils = new Utils();
    mainLayout.init();
    navbarItemsList.init();

    utils.configureJqueryValidator(jq, window.localization);
    utils.configureJqueryValidator($, window.localization);
});
